export const RESET_INTERNAL_MARKETER_EDIT_PRODUCT = 'RESET_INTERNAL_MARKETER_EDIT_PRODUCT';
export type RESET_INTERNAL_MARKETER_EDIT_PRODUCT = typeof RESET_INTERNAL_MARKETER_EDIT_PRODUCT;

export interface ResetInternalMarketerEditProduct {
    type: RESET_INTERNAL_MARKETER_EDIT_PRODUCT;
}

export function resetInternalMarketerEditProductAction(): ResetInternalMarketerEditProduct {
    return {
        type: RESET_INTERNAL_MARKETER_EDIT_PRODUCT
    };
}
